import { FC, forwardRef } from 'react';
import styled from 'styled-components';
import { StepItemResponse } from '@/shared/api';
import { themeConfig, useThemeContext } from '@/shared/theme';
import { StepItem } from './StepItem';

type Props = {
  steps: StepItemResponse[];
  ref?: any;
  selectedStepId: string | undefined;
  onStepSelect: (id: string) => void;
};

export const StepsSidebar: FC<Props> = forwardRef(
  ({ steps = [], selectedStepId, onStepSelect }, ref) => {
    const { theme } = useThemeContext();

    return (
      <SidebarWrapper
        ref={ref}
        style={{
          background: themeConfig[theme].colors.layoutBg,
          color: themeConfig[theme].colors.text,
        }}
      >
        <SidebarHeader>
          <div>Steps</div>
        </SidebarHeader>
        <SidebarContent
          style={{ borderTop: `1px solid ${themeConfig[theme].colors.border}` }}
        >
          {steps?.map((step: StepItemResponse, index: number) => (
            <StepItem
              key={step?.id}
              step={step}
              index={index}
              selectedStepId={selectedStepId}
              onStepSelect={onStepSelect}
            />
          ))}
        </SidebarContent>
      </SidebarWrapper>
    );
  },
);

const SidebarWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  max-height: calc(100vh - 50px);
  overflow-y: hidden;
`;

const SidebarHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  padding: 15px;
`;

const SidebarContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  border-top: 1px solid #eee;
  overflow-y: auto;
  padding-bottom: 20px;
`;
